export const SECTION_ID = {
  AVAILABILITIES_AND_RESTRICTIONS: 'availabilities_and_restrictions',
  // COMPARE_PLAN: 'compare_plan',
  // COST_COMPARISON: 'cost_comparison',
  WHY_JOIN: 'why_join',
  HOW_IT_WORKS: 'how_it_works',
  PARTICIPATING_LOCATIONS: 'participating_locations',
  FAQS: 'faqs',
  RESTRICTIONS: 'restrictions',
};
